import { useEffect } from "react";
import { useLocation } from "react-router-dom";

interface DataLibraryPageProps {
  [key: string]: any;
}

function DataLibraryPage(props: DataLibraryPageProps): JSX.Element {
  const location: any = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return (
    <div className="w-full h-full bg-slate-50">
      <div className="w-full">
        <h1 className="font-sans flex items-start text-2xl p-4 pl-12">
          {" "}
          Data Library{" "}
        </h1>
      </div>
      <div className=" flex  gap-8 pl-10 bg-slate-50 w-full">
        <div className="flex flex-row p-4 gap-6 w-full">
          <div className="flex flex-col p-4 gap-4 border rounded-sm bg-white self-stretch flex-1">
            <h3 className="font-sans text-xl ">Private Data</h3>
            <p className="font-sans text-sm text-gray-700">
              {" "}
              Your Business Data Whether stored in a csv, database or 3rd party
              system.{" "}
            </p>
            <div className="flex flex-col items-start gap-6 self-stretch">
              <div className="flex justify-between items-center self-stretch">
                <div className="flex items-center gap-3">
                  <img
                    src="/assets/images/DataLibrary/csvImage.png"
                    alt=""
                    className="w-12 h-12"
                  />
                  <div className="flex w-[246px] flex-col justify-center items-start self-stretch">
                    <h6>File Upload</h6>
                    <p>Comma Separated Value (CSV) </p>
                  </div>
                </div>

                <div className="flex w-[101px] h-10 justify-center items-center gap-2">
                  <button></button>
                  <button></button>
                </div>
              </div>

              <div className="flex justify-between items-center self-stretch">
                <div className="flex items-center gap-3">
                  <img
                    src="/assets/images/DataLibrary/S4Hana.png"
                    alt=""
                    className="w-12 h-12"
                  />
                  <div className="flex w-[246px] flex-col justify-center items-start self-stretch">
                    <h6>S/4 HANA </h6>
                    <p>SAP</p>
                  </div>
                </div>

                <div className="flex w-[101px] h-10 justify-center items-center gap-2">
                  <button></button>
                  <button></button>
                </div>
              </div>

              <div className="flex justify-between items-center self-stretch flex-1">
                <div className="flex items-center gap-3">
                  <img
                    src="/assets/images/DataLibrary/HubSpot.png"
                    alt=""
                    className="w-12 h-12"
                  />
                  <div className="flex w-[246px] flex-col justify-center items-start self-stretch">
                    <h6>Commerce Hub</h6>
                    <p>Hubspot</p>
                  </div>
                </div>

                <div className="flex w-[101px] h-10 justify-center items-center gap-2">
                  <button></button>
                  <button></button>
                </div>
              </div>
            </div>
          </div>
          
          <div className="flex flex-col p-4 gap-6 border rounded-sm bg-white self-stretch flex-1">
            <h3 className="font-sans text-xl ">Public Data</h3>
            <p className="font-sans text-sm text-gray-700">
              Complimentary data from external providers that can assist in
              analysis
            </p>
            <div className="flex justify-between items-center self-stretch">
              <div className="flex items-center gap-3">
                <img
                  src="/assets/images/DataLibrary/Weather.png"
                  alt=""
                  className="w-12 h-12"
                />
                <div className="flex w-[246px] flex-col justify-center items-start self-stretch">
                  <h6>Weather Api</h6>
                  <p>weather</p>
                </div>
              </div>

              <div className="flex w-[101px] h-10 justify-center items-center gap-2">
                <button></button>
                <button></button>
              </div>
            </div>
            <div className="flex justify-between items-center self-stretch">
              <div className="flex items-center gap-3">
                <img
                  src="/assets/images/DataLibrary/Googlemaps.png"
                  alt=""
                  className="w-12 h-12"
                />
                <div className="flex w-[246px] flex-col justify-center items-start self-stretch">
                  <h6>Traffic API</h6>
                  <p>Google Maps</p>
                </div>
              </div>

              <div className="flex w-[101px] h-10 justify-center items-center gap-2">
                <button></button>
                <button></button>
              </div>
            </div>

            <div className="flex justify-between items-center self-stretch">
              <div className="flex items-center gap-3">
                <img
                  src="/assets/images/DataLibrary/shipping.png"
                  alt=""
                  className="w-12 h-12"
                />
                <div className="flex w-[246px] flex-col justify-center items-start self-stretch">
                  <h6>International Shipping API</h6>
                  <p>Freightos Developers</p>
                </div>
              </div>

              <div className="flex w-[101px] h-10 justify-center items-center gap-2">
                <button></button>
                <button></button>
              </div>
            </div>
          </div>
          {/* <div className='flex flex-col items-start gap-6 self-stretch'> 
          </div> */}
        </div>
      </div>
    </div>
  );
}

export default DataLibraryPage;
